import { useEffect, useRef, useState } from 'react';
import { useGoogleMap } from '@react-google-maps/api';
import { HeatmapCenter } from './useCentersData';
import { createCenterIcon } from './centerIconUtils';
import { CenterEventDialog } from './CenterEventDialog';

interface CenterMarkersComponentProps {
  centers: HeatmapCenter[];
}

export const CenterMarkersComponent = ({ centers }: CenterMarkersComponentProps) => {
  const map = useGoogleMap();
  const markersRef = useRef<google.maps.Marker[]>([]);
  const [selectedCenter, setSelectedCenter] = useState<HeatmapCenter | null>(null);
  const [dialogOpen, setDialogOpen] = useState(false);

  useEffect(() => {
    if (!map || !window.google || !centers || centers.length === 0) {
      return;
    }

    markersRef.current.forEach(marker => {
      marker.setMap(null);
    });
    markersRef.current = [];

    const validCenters = centers.filter(center => center.lat && center.lng && !isNaN(center.lat) && !isNaN(center.lng));

    validCenters.forEach(center => {
      if (!center.lat || !center.lng || isNaN(center.lat) || isNaN(center.lng)) return;

      const position = new google.maps.LatLng(center.lat, center.lng);

      const icon = createCenterIcon();

      const marker = new google.maps.Marker({
        position,
        map,
        icon,
        optimized: false,
        clickable: true
      });

      marker.addListener('click', () => {
        setSelectedCenter(center);
        setDialogOpen(true);
      });

      markersRef.current.push(marker);
    });

    return () => {
      markersRef.current.forEach(marker => {
        marker.setMap(null);
        google.maps.event.clearInstanceListeners(marker);
      });
      markersRef.current = [];
    };
  }, [map, centers]);

  return (
    <CenterEventDialog
      open={dialogOpen}
      onClose={() => {
        setDialogOpen(false);
        setSelectedCenter(null);
      }}
      center={selectedCenter}
    />
  );
};
